import { z } from 'zod';
import { transactionTypeSchema } from '../transactions.js';
/**
 * The audit ledger as read (REQUIREMENTS §2.6 "Full audit ledger with
 * filters"). Read-only by construction: there is no write contract here,
 * because nothing outside `functions/node/src/ledger.ts` writes it.
 */
export const ledgerEntrySchema = z.object({
    id: z.string().min(1),
    type: transactionTypeSchema,
    actorUid: z.string(),
    soldierUid: z.string().nullable(),
    catalogItemId: z.string().nullable(),
    inventoryUnitId: z.string().nullable(),
    quantity: z.number().nullable(),
    formId: z.string().nullable(),
    assignmentId: z.string().nullable(),
    fromUid: z.string().nullable(),
    toUid: z.string().nullable(),
    before: z.unknown(),
    after: z.unknown(),
    notes: z.string().nullable(),
    createdAt: z.string().nullable(),
});
/** GET /api/ledger — company-wide roles only. Newest first. */
export const ledgerQuerySchema = z.object({
    type: transactionTypeSchema.optional(),
    soldierUid: z.string().min(1).optional(),
    actorUid: z.string().min(1).optional(),
    catalogItemId: z.string().min(1).optional(),
    /** ISO datetimes: `from` inclusive, `to` exclusive. */
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(200),
});
export const ledgerResponseSchema = z.object({
    entries: z.array(ledgerEntrySchema),
    /** Display names for every uid that appears, so a row reads without a lookup. */
    people: z.array(z.object({ uid: z.string(), name: z.string() })),
    items: z.array(z.object({ id: z.string(), nameHe: z.string(), nameEn: z.string() })),
});
//# sourceMappingURL=ledger.js.map